
import React from 'react';

interface StarIconProps extends React.SVGProps<SVGSVGElement> {}

const TealStarIcon: React.FC<StarIconProps> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    {...props}
  >
    <path 
      fillRule="evenodd" 
      d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.501 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354l-4.502 2.825c-.995.608-2.23-.29-1.96-1.425l1.257-5.273-4.117-3.501c-.887-.76-.415-2.212.749-2.305l5.404-.434L10.788 3.21Z" 
      clipRule="evenodd" 
    />
  </svg>
);

export default TealStarIcon;
